import { Box, Button, Input, InputBaseComponentProps } from "@mui/material";
import { ChangeEvent, PropsWithChildren, RefObject, useRef } from "react";

interface InputFileProps extends PropsWithChildren {
  inputProps?: InputBaseComponentProps;
  onChange?: (_e: ChangeEvent<HTMLInputElement>) => void;
  inputRef?: RefObject<HTMLInputElement>;
}

export const InputFile = ({
  children,
  inputProps,
  onChange,
  inputRef,
}: InputFileProps) => {
  const internalRef = useRef<HTMLInputElement>(null);
  const fileInputRef = inputRef || internalRef;

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box position={"relative"}>
      <Input
        type="file"
        inputRef={fileInputRef}
        inputProps={inputProps}
        sx={{
          position: "absolute",
          paddingLeft: "150px",
          pointerEvents: "none",
          "& input::-webkit-file-upload-button, &::after, &::before": {
            display: "none",
          },
          fontSize: "12px",
          marginTop: "4px",
        }}
        onChange={onChange}
      />
      <Button
        variant="contained"
        size="small"
        sx={{ width: 135 }}
        onClick={handleClick}
      >
        {children}
      </Button>
    </Box>
  );
};
